import { render, staticRenderFns } from "./MonthlyTaxSubmissionRecordEdit.vue?vue&type=template&id=117636a6"
import script from "./MonthlyTaxSubmissionRecordEdit.vue?vue&type=script&lang=js"
export * from "./MonthlyTaxSubmissionRecordEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports